import { render, staticRenderFns } from "./BmpCanvas.vue?vue&type=template&id=156b0da1"
import script from "./BmpCanvas.vue?vue&type=script&lang=js"
export * from "./BmpCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports